var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopStreamCardSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 10,
  viewBox: "0 0 11 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.256 5.75V2.926a.4.4 0 0 0-.13-.31.44.44 0 0 0-.316-.123H4.984a.43.43 0 0 0-.305.123.4.4 0 0 0-.129.31.4.4 0 0 0 .13.31.43.43 0 0 0 .304.124h1.77L2.98 7.13a.42.42 0 0 0-.13.31q0 .182.13.31.13.13.31.13a.42.42 0 0 0 .311-.13l3.776-3.77V5.75q0 .187.13.317.128.128.31.128a.42.42 0 0 0 .31-.128.43.43 0 0 0 .13-.317M1.126 0h8.748q.47 0 .798.328.328.327.328.796v7.752q0 .468-.328.796a1.09 1.09 0 0 1-.798.328H1.126q-.47 0-.798-.328A1.08 1.08 0 0 1 0 8.876V1.124Q0 .656.328.328.658 0 1.126 0"
})));
export default SvgTwitterDesktopStreamCardSm;